let apiServer = {}

switch (process.env.VUE_APP_API ? process.env.VUE_APP_API : process.env.NODE_ENV) {
  case 'development':
    apiServer = require('./dev')
    break
  case 'test':
    apiServer = require('./test')
    break
  case 'production':
    apiServer = require('./prod')
    break
  case 'prod-huaihelu':
    apiServer = require('./prod-huaihelu')
    break
  case 'test-huaihelu':
    apiServer = require('./test-huaihelu')
    break
  default:
    apiServer = require('./dev')
}

export default apiServer
